
<script>
	import listBase from '@_system/components/base/list.vue'
	import importconfig from './importconfig/index.vue'
	import buttonauth from './buttonauth/index.vue'
	export default {
		extends: listBase,
		name:'formIndex',
		props: {

		},
		data() {
			return {
				componenttype:'system',
				moduleName: 'form',
				windowName: '表单管理',
				formid:0,
			}
		},
		render(h) {
			this.$slots.plug = [
				<importconfig ref="importconfig" formid={this.formid} />,
				<buttonauth ref="buttonauth"  />
			]			
			return listBase.render.call(this, h)
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			buttonauth(){
				this.$refs.buttonauth.modal_show()
			},
			beforeCreateGrid(formConfig,columns){
				columns.forEach((item)=>{
					if(item.field=='name'){
						item.slots = {
							default: ({row}) => {	
								let str= []								
								if(row.flowid){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">流</el-tag>)
								}	
								if(row.formconfigid){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">导</el-tag>)
								}	
								str.push(<span>{row.name}</span>)							
								return str
							}
						}
					}
				})
				
			},
			beforeRender(res) {
				res.list.forEach((item)=>{
					if(item.listtype==1){
						item.listtype = '普通模式'
					}
					if(item.listtype==2){
						item.listtype = '分级模式(严格)'
					}
					if(item.listtype==3){
						item.listtype = '分级模式(宽松)'
					}
					if(item.listtype==4){
						item.listtype = '分级模式(共享)'
					}
				})
			},

			add() {
				import('@_system/components/forms/form/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						id: 0,
						name: 'form',
						show: true,
						controlltype: 1,
					}
				})

			},
			edit(row) {
				import('@_system/components/forms/form/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						id: row.id,
						name: 'form',
						show: true,
						controlltype: 2,
					}
				})
			},
			preview(e) {
				import('@_system/components/forms/form/preview.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: '',
						show: true,
						extra: {
							rule: e.rule,
							title: e.title
						}
					}
				})
			},
			controll(e) {
				import('./controll/index.vue').then((res) => {
					
					this.indexModule = {
						component: res.default,
						show: true,
						foreingKey: {
							formid: e.id
						},
						extra: {
							notice: '操作列表',
							title: e.title
						}

					}
					console.log(this.indexModule)
				})
			},
			flow(e) {
				import('./flow/index.vue').then((res) => {
					this.indexModule = {
						component: res.default,
						show: true,
						foreingKey: {
							formid: e.id
						},
						extra: {
							notice: '流程列表',
							title: e.title
						}
					}
				})
			},
			config(row){
				this.formid = row.id
				this.$refs.importconfig.modal_show()
			},
			cellClick({
				row,
				column
			}) {
				if (column.field != '') {
					this.preview(row)
				}
			}
		},
		components: {
			buttonauth	
		}
	}
</script>
